import { mergeProps } from 'solid-js';
import { JSXElement } from 'solid-js';

function Notice(incomingProps: { children?: JSXElement; type?: 'brand' | 'normal'; class?: string }) {
  // mergeProps 保留了 props 的响应性
  const props = mergeProps({ type: 'brand', children: '' }, incomingProps);

  return (
    <div
      class={cx(
        `rounded-lg p-2 flex items-start gap-2 text-sm ${
          props.type === 'brand' ? 'bg-alpha-brand-brand-a5' : 'bg-layer4'
        } ${props.type === 'brand' ? 'text-brand-default' : 'text-neutral-main2'}`,
        props.class
      )}
    >
      <IconCheckWarning
        class={`flex-none size-4 mt-[3px] ${props.type === 'brand' ? 'text-brand-default' : 'text-neutral-main2'} `}
      />
      {props.children}
    </div>
  );
}

export default Notice;
